<template>
  <v-app>
    <v-app-bar app color="#bdce2a" dark>
      <img src="@/assets/811_Trans_bgnd.png" height="48" />
      <v-spacer></v-spacer>
      <router-link to="/">
        <div class="d-lg-flex display-1 white--text">
          CO811 Ticket Attachments
        </div>
      </router-link>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
